const SHOW_ALL = "SHOW_ALL";
const ACTIVATED = "ACTIVATED";
const DEACTIVATED = "DEACTIVATED";

export { SHOW_ALL, ACTIVATED, DEACTIVATED };
